import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorDealsState = (state: RootState) => state.deals;

export const selectorDeals = createSelector(
  selectorDealsState,
  (dealsState) => dealsState
);
